var styleDataHash = '2171eb73';  
export const injectCss = (() => {
  var css = `.DH1zO{--wds-side-panel-content-padding-vertical:0px}[dir] .FGF2D{padding-bottom:calc(var(--wds-side-panel-footer-padding-vertical, 18px)*2 + var(--wds-button-size-small, 30px))!important}.x877h{--wds-side-panel-footer-padding-vertical:18px;bottom:0;position:absolute}[dir] .x877h{background:var(--wds-color-fill-surface-overlay,var(--wsr-color-D80,#fff))}[dir=ltr] .x877h,[dir=rtl] .x877h{left:0;right:0}.tzUn6{height:100%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "content": "DH1zO",
  "contentWithFooter": "FGF2D",
  "footer": "x877h",
  "fullscreen": "tzUn6"
};